import React from 'react';
import { useTranslation } from '@hooks/useTranslation';

const FormActions = ({
    onCancel,
    loading = false,
    mode = 'edit',
    isEditing = false
}) => {
    const { t } = useTranslation();

    const getSubmitButtonLabel = () => {
        if (loading) return t('common.loading');

        switch (mode) {
            case 'borrow': return t('borrowing.borrow');
            case 'return': return t('borrowing.return');
            default: return isEditing ? t('common.save') : t('common.create');
        }
    };

    return (
        <div className="form-actions">
            {onCancel && (
                <button
                    type="button"
                    onClick={onCancel}
                    className="btn btn-secondary"
                    disabled={loading}
                >
                    {t('common.cancel')}
                </button>
            )}
            <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
            >
                {getSubmitButtonLabel()}
            </button>
        </div>
    );
};

export default FormActions;
